import { render, staticRenderFns } from "./PrivacyCookies.vue?vue&type=template&id=018e88e4&scoped=true"
import script from "./PrivacyCookies.vue?vue&type=script&lang=js"
export * from "./PrivacyCookies.vue?vue&type=script&lang=js"
import style0 from "./PrivacyCookies.vue?vue&type=style&index=0&id=018e88e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e88e4",
  null
  
)

export default component.exports